import { render, staticRenderFns } from "./IconPriceListHome.vue?vue&type=template&id=1c070c94&"
import script from "./IconPriceListHome.vue?vue&type=script&lang=js&"
export * from "./IconPriceListHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports